import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { NotificationManagementContainerComponent } from './components/notification-management-container/notification-management-container.component'
import { NotificationListComponent } from './components/notification-list/notification-list.component'

const routes: Routes = [
  {
    path: '',
    component: NotificationManagementContainerComponent,
    children: [
      {
        path: '',
        redirectTo: 'notifications',
        pathMatch: 'full',
      },
      {
        path: 'notifications',
        component: NotificationListComponent,
      },
    ],
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NotificationManagementRoutingModule {}
